module.exports = __webpack_public_path__ + "static/fonts/Fact-Narrow.bf17ac2.woff2";